<script lang="ts">
	//UI
	import { AdaptiveTextInput } from "@hitit/new_ui";
	//Utils

	//Types
	//Props
	export let name = "";
	export let text = "";
	export let value = "";
	export let editmode = false;
	export let placeholder = "";
	export let input = false;
	export let tid = "";
	export let clearCallback: () => void = () => {
		value = "";
	};
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="container" t-id={tid}>
	{#if name}
		<div class="name-box">
			<p class="name">{name}</p>
		</div>
	{/if}
	{#if input}
		<div class="value-box">
			{#if editmode}
				<div class="input-wrapper">
					<AdaptiveTextInput
						bind:value
						clearButtonDisplay={value !== ''}
						clearCallback={clearCallback}
						backgroundColor={'#f0f0f4'} />
				</div>
			{:else}
				<p class="text">{value ? value : placeholder}</p>
			{/if}
			<slot name="button" />
		</div>
	{:else}
		<div class="value-box">
			<p class="text">{value ? `${text} = ${value}` : text}</p>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;

		.value-box {
			display: flex;
			align-items: center;
			gap: 20px;
			flex-grow: 1;
		}
		.input-wrapper {
			display: flex;
			flex-grow: 1;
			height: 32px;
			color: #46474b;
		}
		.input {
			flex-grow: 1;
			height: 32px;
			border: none;
		}
		.name {
			color: #46474b;
			line-height: 22px;
		}

		.text {
			font-weight: 500;
			color: #46474b;
			line-height: 22px;
		}
	}

	@include DesktopSize {
		.container {
			.name {
				color: #46474b;
				line-height: 22px;
				font-size: 1.25rem;
			}

			.text {
				color: #46474b;
				line-height: 22px;
				font-size: 1.25rem;
			}

			.input-wrapper {
				font-size: 1.25rem;
				height: 40px;
				max-width: 300px;
			}
		}
	}

</style>
